document.addEventListener('DOMContentLoaded', () => {
  // Mini Cart Drawer toggles
  const cartButtons = document.querySelectorAll('[aria-label="Cart"]');
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartDrawerOverlay');
  const closeCartBtn = document.getElementById('CloseCartDrawer');

  function openCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('translate-x-full');
      cartOverlay.classList.remove('opacity-0', 'pointer-events-none');
      cartOverlay.classList.add('opacity-100');
    }
  }

  function closeCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('translate-x-full');
      cartOverlay.classList.add('opacity-0', 'pointer-events-none');
      cartOverlay.classList.remove('opacity-100');
    }
  }

  cartButtons.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));

  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Search Toggle
  const searchTrigger = document.getElementById('HeaderSearchTrigger');
  const searchForm = document.getElementById('HeaderSearchForm');
  if (searchTrigger && searchForm) {
    searchTrigger.addEventListener('click', (e) => {
      e.stopPropagation();
      searchForm.classList.toggle('active');
    });
    // Close search form if clicked outside
    document.addEventListener('click', (e) => {
      if (searchForm && !searchForm.contains(e.target) && e.target !== searchTrigger) {
        searchForm.classList.remove('active');
      }
    });
  }


  // Handle Add to Cart AJAX (mock or actual Shopify API wrapper)
  document.querySelectorAll('form[action$="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });
        if (response.ok) {
          // Refresh cart drawer items and open drawer
          await updateCartDrawer();
          openCart();
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    });
  });

  async function updateCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const container = document.getElementById('CartDrawerItems');
      const countBads = document.querySelectorAll('[aria-label="Cart"] span');
      const subtotalEl = document.getElementById('CartDrawerSubtotal');
      
      // Update counts
      countBads.forEach(badge => {
        badge.textContent = cart.item_count;
      });

      if (subtotalEl) {
        subtotalEl.textContent = '₹' + (cart.total_price / 100).toLocaleString('en-IN');
      }

      if (!container) return;

      if (cart.item_count === 0) {
        container.innerHTML = `
          <div class="text-center py-12 text-muted-foreground">
            <p class="mb-4">Your cart is empty.</p>
            <button class="bg-amber px-6 py-2.5 rounded-md font-semibold text-foreground hover:bg-amber-deep transition" onclick="document.getElementById('CloseCartDrawer').click();">Start Shopping</button>
          </div>
        `;
        return;
      }

      let html = '<div class="space-y-4">';
      cart.items.forEach((item, idx) => {
        const itemImg = item.image || (window.theme ? window.theme.placeholderImage : '');
        const itemKey = item.key || item.id;
        html += `
          <div class="flex items-center gap-4 py-3 border-b border-border/20">
            <img src="${itemImg}" alt="${item.title}" class="h-16 w-16 rounded-lg object-contain bg-ivory p-1 border border-border/40" loading="lazy">
            <div class="flex-1 min-w-0">
              <h4 class="font-semibold text-sm truncate text-foreground">${item.product_title}</h4>
              <p class="text-xs text-muted-foreground">${item.variant_title || ''}</p>
              <div class="flex items-center gap-2 mt-2">
                <div class="inline-flex items-center rounded border border-border bg-background">
                  <button type="button" class="px-2 py-0.5 text-xs text-teal font-bold hover:bg-teal-soft" onclick="window.changeQuantity('${itemKey}', ${item.quantity - 1})">-</button>
                  <span class="px-2 text-xs font-semibold">${item.quantity}</span>
                  <button type="button" class="px-2 py-0.5 text-xs text-teal font-bold hover:bg-teal-soft" onclick="window.changeQuantity('${itemKey}', ${item.quantity + 1})">+</button>
                </div>
                <span class="text-xs font-bold text-teal">₹${(item.final_line_price / 100).toLocaleString('en-IN')}</span>
              </div>
            </div>
            <button type="button" class="p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition text-xs font-medium" onclick="window.changeQuantity('${itemKey}', 0)" aria-label="Remove item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2"><path d="3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
            </button>
          </div>
        `;
      });
      html += '</div>';
      container.innerHTML = html;
    } catch (e) {
      console.error('Error fetching cart:', e);
    }
  }

  // Initial cart drawer load
  updateCartDrawer();

  // Define global quantity change function for cart items
  window.changeQuantity = async (id, qty) => {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: String(id), quantity: parseInt(qty, 10) })
      });
      if (res.ok) {
        await updateCartDrawer();
      }
    } catch (e) {
      console.error('Error updating cart item:', e);
    }
  };
});

